import TreeComponent from './Tree.vue';
import TreeOptions from './TreeOptions.vue';
import defaultTreeConfig from './defaultTreeConfig';

export * from './types';
export * from './treeHelpers';
export {
    TreeComponent as default,
    TreeComponent,
    TreeOptions,
    /**
     * @todo: stop exporting this outside of Table
     * remove after rewrite all tables with this component
     */
    defaultTreeConfig,
};
